import type { RoleConfig } from '../types.js';

export const cultist: RoleConfig = {
  id: 'cultist',
  faction: 'solo',
  title: { ru: 'Культист', uk: 'Культист' },
  latin: 'CULTIST',
  number: '50',
  accent: '#9a3ad6',
  sub: '#3a1078',
  ability: {
    ru: 'Ночью вербует мирного жителя в свой культ. Побеждает, когда культ (он сам и завербованные) становится большинством среди живых.',
    uk: 'Уночі вербує мирного жителя у свій культ. Перемагає, коли культ (він сам і завербовані) стає більшістю серед живих.',
  },
  abilities: [
    { key: 'convert', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  victory: { type: 'solo-cult-parity' },
};
